/**
 * Pure helpers for the Customer Groups admin page.
 *
 * Kept in a sibling module so the unit-test layer can exercise them
 * without instantiating the full React tree.
 */

/**
 * Pluralised "N customers selected" / "1 customer selected" /
 * "No customers selected" label used in the create/edit dialog
 * footer.
 */
export const formatMemberCountLabel = (count: number): string => {
  if (count <= 0) return 'No customers selected'
  if (count === 1) return '1 customer selected'
  return `${count} customers selected`
}

/**
 * Render a customer typeahead row into the "12345678 — Acme A/S"
 * label used in chips and dropdown items.
 */
export const formatCustomerOptionLabel = (customer: {
  local_id: string
  name: string
}): string => `${customer.local_id} — ${customer.name}`

/**
 * Returns true if two arrays of numbers contain the same values,
 * order-independent. Used by the edit dialog to decide whether the
 * member list actually changed.
 */
export const sameCustomerIdSet = (a: number[], b: number[]): boolean => {
  if (a.length !== b.length) return false
  const seen = new Set(a)
  return b.every((x) => seen.has(x))
}
